import type { Scopes } from '@atlassian/post-office-context';

/**
 * Scopes configuration for the jsm-live-chat-notifications placement.
 *
 * This placement should only subscribe to live chat notifications while the
 * agent is in Jira Service Management.
 */
export const scopes: Scopes = [
	{
		name: 'jira/servicedesk',
		when: {
			context: { product: 'jira' },
			route: {
				pathname: {
					matches: 'jira/servicedesk',
				},
			},
		},
	},
];
